export * from './vehicle-operational-status-icon.component';
export * from './vehicle-operational-status-icon.view-model';
